import React from 'react'
import compose from 'recompose/compose'
import Card from '@material-ui/core/Card'
import Brightness7Icon from '@material-ui/icons/Brightness7';
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { translate } from 'react-admin'

import CardIcon from './CardIcon'

const styles = {
  main: {
    flex: '1',
    marginLeft: '1em',
    marginTop: 20,
  },
  card: {
    overflow: 'inherit',
    textAlign: 'right',
    padding: 16,
    minHeight: 52,
  },
}

const TotalBuffs = ({ value, translate, classes }) => (
  <div className={classes.main}>
    <CardIcon Icon={Brightness7Icon} bgColor="#ff9800" />
    <Card className={classes.card}>
      <Typography className={classes.title} color="textSecondary">
        Total Buffs
      </Typography>
      <Typography variant="headline" component="h2">
        {value}
      </Typography>
    </Card>
  </div>
)

const enhance = compose(
  withStyles(styles),
  translate
)

export default enhance(TotalBuffs)
